import { capitalize } from 'lodash';
import { MIXPANEL_PAGE_NAMES } from './constants';

export const getPageNameForMixPanel = (pageName) => ({ 'Page Name': MIXPANEL_PAGE_NAMES[pageName] });
export const convertElementNameForMixPanel = (elementName) =>
    capitalize(elementName.replace(new RegExp('_', 'g'), ' '));
export const convertSellerForMixPanel = (seller) => ({ 'Seller Id': seller.id, 'Seller Username': seller.username });
